import React from "react";
import PropTypes from "prop-types";
import MaterialTable from "material-table";
import { tableIcons, getTableHeader } from "../utils/tableHeaders";
import { CsvBuilder } from "filefy";
import jsPDF from "jspdf";
import "jspdf-autotable";

/**
 * Generic data table component for simpler tables
 */
export const DataTable = ({
  title,
  description,
  data,
  tableType,
  selectedRows = [],
  exportFileName,
  actions = [],
  options = {},
}) => {
  if (!data || data.length === 0) {
    return null;
  }

  const defaultOptions = {
    selection: true,
    sorting: true,
    exportAllData: true,
    exportButton: true,
    exportFileName: exportFileName || title,
    ...options,
  };

  const tableData = selectedRows.length > 0
    ? data.map((row) =>
        selectedRows.find((selected) => selected.id === row.id)
          ? { ...row, tableData: { checked: true } }
          : row
      )
    : data;

  return (
    <div style={{ width: "100%" }}>
      <MaterialTable
        style={{ marginTop: "10px", marginBottom: "10px" }}
        icons={tableIcons}
        key={`${tableType}Table`}
        title={
          description ? (
            <div style={{ marginTop: "10px" }}>
              <h2>{title}</h2>
              {description && <p style={{ fontSize: "125%" }}>{description}</p>}
            </div>
          ) : (
            title
          )
        }
        columns={getTableHeader(tableType)}
        data={tableData}
        options={defaultOptions}
        actions={actions}
      />
    </div>
  );
};

DataTable.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  data: PropTypes.array.isRequired,
  tableType: PropTypes.string.isRequired,
  selectedRows: PropTypes.array,
  exportFileName: PropTypes.string,
  actions: PropTypes.array,
  options: PropTypes.object,
};

/**
 * Helper function to create export actions for tables
 */
export const createExportActions = (tableType, fileName) => {
  return [
    {
      position: "toolbarOnSelect",
      icon: tableIcons.ExportCSV,
      tooltip: "Export selected as CSV",
      onClick: (e, rowData) => {
        const columnTitles = getTableHeader(tableType).map(
          (columnDef) => columnDef.title
        );
        const csvData = rowData.map((data) =>
          getTableHeader(tableType).map((columnDef) => {
            if (columnDef.render) {
              return columnDef.render(data);
            }
            return data[columnDef.field];
          })
        );
        const builder = new CsvBuilder(`${fileName}.csv`)
          .setColumns(columnTitles)
          .addRows(csvData)
          .exportFile();
      },
    },
    {
      position: "toolbarOnSelect",
      icon: tableIcons.ExportPDF,
      tooltip: "Export selected as PDF",
      onClick: (e, rowData) => {
        const doc = new jsPDF();
        const columnTitles = getTableHeader(tableType).map(
          (columnDef) => columnDef.title
        );
        const pdfData = rowData.map((data) =>
          getTableHeader(tableType).map((columnDef) => {
            if (columnDef.render) {
              return columnDef.render(data);
            }
            return data[columnDef.field];
          })
        );
        doc.autoTable({
          head: [columnTitles],
          body: pdfData,
        });
        doc.save(`${fileName}.pdf`);
      },
    },
  ];
};

